import React from 'react';
import { useAdminAuth } from '@/hooks/useAdminAuth';
import AdminAuth from './AdminAuth';
import DynamicMetaTags from '@/components/DynamicMetaTags';

interface AdminProtectedRouteProps {
  children: React.ReactNode;
}

const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAdminAuth();

  // Emit noindex/nofollow for every admin route regardless of auth state, so
  // the unauthenticated login view is also kept out of search indexes.
  return (
    <>
      <DynamicMetaTags isAdminPage={true} />
      {isAuthenticated ? <>{children}</> : <AdminAuth />}
    </>
  );
};

export default AdminProtectedRoute;
